//
//
//
//

export default {
  props: {
    title: {
      required: false,
    },
  },
};
